/**
 * Web stub for react-native/Libraries/StyleSheet/PlatformColorValueTypes.
 * Platform-specific color objects are not used on web.
 */
export const PlatformColor = (...names) => ({ resource_paths: names });

export const normalizeColorObject = () => null;

export const processColorObject = (color) => color ?? null;
